var styleDataHash = "19b34475";
const injectCss = () => {
  var css = `.H-Zxh,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.PHyH8{--ricos-custom-p-font-size:14px;align-items:center;color:var(--ricos-custom-p-color,unset);display:flex;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);letter-spacing:var(--ricos-custom-p-letter-spacing,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-decoration:var(--ricos-custom-p-text-decoration,unset)}[dir] .PHyH8{text-align:center}[dir] .PHyH8>span>a,[dir] .PHyH8>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){.PHyH8{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){.PHyH8{font-size:var(--ricos-custom-p-font-size,unset)}}.FYiH7{margin-inline-start:-8px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var caption_default = {
  "fontElementMap": "H-Zxh",
  "caption": "PHyH8",
  "aiButtonContainer": "FYiH7"
};
export {
  caption_default as default,
  injectCss
};
//# sourceMappingURL=caption-scss.js.map
